import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { exportPaymentReport, getPaymentReport, paymentError, refreshPayment } from "../api/payments";

export const initialPaymentFilters = { page: 1, limit: 25, search: "", status: "", gatewayCode: "", mode: "", from: "", to: "" };
export default function usePaymentReport() {
  const token = useSelector((state) => state.user.token);
  const [filters, setFilters] = useState(() => ({ ...initialPaymentFilters,
    search: new URLSearchParams(window.location.search).get("search")?.slice(0, 200) || "" })), [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({ rows: [], total: 0, headers: [] }), [loading, setLoading] = useState(true);
  const [error, setError] = useState(""), [busyId, setBusyId] = useState(""), [exporting, setExporting] = useState(false);
  const [actionError, setActionError] = useState("");
  const [notice, setNotice] = useState(null);
  const refreshing = useRef(false);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError(""); setActionError("");
    getPaymentReport(token, filters, controller.signal).then((value) => {
      if (!controller.signal.aborted) {
        const last = Math.max(1, Math.ceil(value.total / filters.limit));
        if (filters.page > last) setFilters((current) => ({ ...current, page: last }));
        else setResult(value);
      }
    }).catch((reason) => { if (!controller.signal.aborted) { setError(paymentError(reason)); setResult({ rows: [], total: 0, headers: [] }); } })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [token, filters, attempt]);
  async function refresh(id) {
    if (refreshing.current) return;
    refreshing.current = true;
    setBusyId(id); setActionError(""); setNotice(null);
    try {
      const refreshed = await refreshPayment(token, id);
      setNotice({ id, status: refreshed.status, pendingRefundId: refreshed.pendingRefundId, awaitingProvider: refreshed.awaitingProvider === true, at: new Date().toLocaleTimeString("fa-IR") });
      setAttempt((value) => value + 1);
    }
    catch (reason) { setActionError(paymentError(reason)); }
    finally { refreshing.current = false; setBusyId(""); }
  }
  async function download() {
    if (exporting || loading || error) return;
    setExporting(true); setActionError("");
    try {
      const blob = await exportPaymentReport(token, filters);
      const url = URL.createObjectURL(blob), link = document.createElement("a");
      link.href = url; link.download = "payment-orders.csv"; document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (reason) { setActionError(paymentError(reason)); }
    finally { setExporting(false); }
  }
  return { ...result, filters, loading, error, actionError, notice, busyId, exporting, refresh, download,
    reload: () => setAttempt((value) => value + 1), setFilters,
    apply: (value) => setFilters({ ...value, page: 1 }), page: (value) => setFilters((current) => ({ ...current, page: value })) };
}
